import { Anchor, Stack } from "@mantine/core";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import LinkWithIcon from "@/components/links/LinkWithIcon";
import { trackEvent } from "@/tracking";
import { createLink } from "./createLink";
import { GuestInfoBite } from "./GuestInfoBite";

interface PrettyLinkItemsProps {
  linkParent: GuestInfoBite;
}

function PrettyLinkItems({ linkParent }: PrettyLinkItemsProps) {
  if (!linkParent.links || linkParent.links.length === 0) return null;

  const parsedLinks: LinkWithIcon[] = linkParent.links.map((og) =>
    createLink(og),
  );

  return (
    <Stack gap={6}>
      {parsedLinks.map((link) => (
        <Anchor
          key={link.url}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          c="sea.7"
          fw={500}
          onClick={() =>
            trackEvent("Guest Info Link Click", {
              section: linkParent.title,
              url: link.url,
              label: link.text,
            })
          }
          style={{ display: "flex", alignItems: "center", gap: 8 }}
        >
          <FontAwesomeIcon icon={link.icon} fixedWidth />
          {link.text}
        </Anchor>
      ))}
    </Stack>
  );
}

export default PrettyLinkItems;
